/**
 * @generated SignedSource<<67096329ee9114aab95bc9bf43b27f69>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IconLink_iconLink$data = {
  readonly iconUrl: string | null | undefined;
  readonly label: string;
  readonly url: string;
  readonly " $fragmentType": "IconLink_iconLink";
};
export type IconLink_iconLink$key = {
  readonly " $data"?: IconLink_iconLink$data;
  readonly " $fragmentSpreads": FragmentRefs<"IconLink_iconLink">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IconLink_iconLink",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iconUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "type": "IconLink",
  "abstractKey": null
};

(node as any).hash = "c70e8d9c066be29e345fbffdb9d63bbc";

export default node;
